import React, { useContext, useRef } from 'react';
import Intl from '@fx-ui/intl';
import { ErrorInput } from '@fx-ui/jdy-design-biz';
import { isEmpty, size, trim } from '~/utils';
import { UGC_MAX_LENGTH } from '~/constants';
import PersonaContext from '../../context/persona';
import PersonaCollectItem from '../persona-collect-item';

const { USER_NICKNAME } = UGC_MAX_LENGTH.USER;

/**
 * 怎么称呼你
 */
const Nickname = () => {
    const { personaInfo, setPersonaInfo } = useContext(PersonaContext);
    const { nickname } = personaInfo || {};

    const nicknameInput = useRef<any>();

    return (
        <PersonaCollectItem className="fx-persona-nickname" title={Intl.get('role.nickname')}>
            <ErrorInput
                style={{ width: '100%' }}
                ref={nicknameInput}
                type="text"
                size="large"
                placeholder={Intl.get('your.name')}
                value={nickname}
                errMsg={
                    size(trim(nickname)) > USER_NICKNAME
                        ? Intl.get('max.length.error.message', { max: USER_NICKNAME })
                        : ''
                }
                inputState={
                    !isEmpty(nickname) && size(trim(nickname)) <= USER_NICKNAME ? 'normal' : 'error'
                }
                onChange={(v) => {
                    setPersonaInfo({
                        nickname: v
                    });
                }}
                errorTrigger="blur"
                autoSelect
            />
        </PersonaCollectItem>
    );
};

export default Nickname;
